import React from 'react';
import times from 'lodash/times';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Shimmer } from '../../../../CommonComponents/OPL/Shimmer/Shimmer';
import { Separator } from '../../../../CommonComponents/OPL/Separator/Separator';

export const WireInstructionsLoading = () => {
  return (
    <Box pt="24" pb="48">
      <Separator />

      {times(6).map(key => (
        <React.Fragment key={key}>
          <Box display="flex" flexDirection="row" px="32" py="12">
            <Shimmer width={100} height={16} css="margin-right: 90px" />
            <Shimmer width={200} height={16} />
          </Box>

          <Separator />
        </React.Fragment>
      ))}
    </Box>
  );
};
